export default __webpack_public_path__ + "static/media/number-input-arrow.91320998.svg";